import { useMemo, useState } from 'react';
import { serviceFaviconUrl } from '../../utils/serviceFavicon';

export default function ServiceFavicon({ svc, name, className = 'h-5 w-5 shrink-0 rounded border border-white/10 bg-slate-900/80' }) {
  const [failed, setFailed] = useState(false);
  const faviconUrl = useMemo(() => serviceFaviconUrl(svc), [svc]);
  const label = String(name || '').trim();
  const initials = label
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';

  if (failed || !faviconUrl) {
    return (
      <span
        className={`flex items-center justify-center text-[7px] font-black text-slate-300 ${className}`}
        aria-hidden
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      src={faviconUrl}
      alt=""
      width={20}
      height={20}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
